import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((app) => {
  const $router = useRouter();
  const {
    SENTRY_DSN,
    SENTRY_ENV,
    SENTRY_TRACES_SAMPLE_RATE,
    SENTRY_REPLAY_SESSION_SAMPLE_RATE,
    SENTRY_REPLAY_ERROR_SAMPLE_RATE,
  } = useRuntimeConfig().public;

  if (SENTRY_DSN) {
    const replaySessionRate = SENTRY_REPLAY_SESSION_SAMPLE_RATE as number;
    const replayErrorRate = SENTRY_REPLAY_ERROR_SAMPLE_RATE as number;
    const isReplayEnabled = replaySessionRate > 0 || replayErrorRate > 0;

    Sentry.init({
      app: app.vueApp,
      dsn: SENTRY_DSN,
      environment: SENTRY_ENV,
      integrations: [
        Sentry.browserTracingIntegration({ router: $router }),
        Sentry.vueIntegration({
          tracingOptions: {
            trackComponents: true,
          },
        }),
        ...(isReplayEnabled ? [Sentry.replayIntegration()] : []),
      ],
      tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE as number,
      replaysSessionSampleRate: replaySessionRate,
      replaysOnErrorSampleRate: replayErrorRate,
      ignoreErrors: ["CancelError"],
    });
  }

  return {
    provide: {
      sentry: Sentry,
    },
  };
});
